jQuery(function($) {

  var toggleCaption = function(e) {
    $(this).toggleClass('hero__caption--active');
    e.preventDefault();
  }


  $('.hero__caption').on('click', toggleCaption);

  var scrollCTA = function(e) {
   $('html, body').animate({
    scrollTop: $('.scroll__to').offset().top},
    'slow');
   e.preventDefault();
 }

 $('.hero__cta').on('click', scrollCTA);

 if (window.innerWidth >= 1024) {
  $('.caption__mobile').attr('aria-hidden', 'true');
  $('.desktop-hidden').attr('aria-hidden', 'true');
} else {
  $('.caption__desktop').attr('aria-hidden', 'true');
  $('.mobile-hidden').attr('aria-hidden', 'true');
}


if (!$('.home__hero__overlay .wrap .hero__caption').length > 0 && $('.home__hero__cta').length) {
  $('.home__hero__cta').css('bottom', '60px');
}






});
